import { getProxyUrl } from '.'

export type UsuarioTienda = {
  idUsuarios: number
  nombre: string
}

export type TiendaConUsuarios = {
  idTiendas: number
  nombreTienda: string
  administrador?: UsuarioTienda
  disenadores?: UsuarioTienda[]
  usuariosFinales?: UsuarioTienda[]
}

export type UsuariosTiendasResponse = {
  tiendas?: TiendaConUsuarios[]
}

export async function getUsuariosTiendas(
  filtro: string = '',
  verUsuariosFinales: boolean = true,
): Promise<UsuariosTiendasResponse> {
  const url = getProxyUrl('api/Auth/usuariosTiendas')
  const params = new URLSearchParams()
  if (filtro) params.append('filtro', filtro)
  params.append('verUsuariosFinales', String(verUsuariosFinales))

  const response = await fetch(`${url}?${params.toString()}`, {
    method: 'GET',
    mode: 'cors',
    headers: {
      Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
      'Accept-Language': 'ES',
    },
  })

  if (!response.ok) {
    const errorDetail = await response.json().catch(() => ({}))
    throw new Error(errorDetail?.detail || 'Error al obtener usuarios de tiendas')
  }

  return response.json() as Promise<UsuariosTiendasResponse>
}
